import { Component, OnInit, Inject, Input, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { IEditOptions } from '../site-edit.component';
import { ManikEntityFE } from 'src/app/manik-library/ManikEntityFE';
import { ManikEntityService } from 'src/app/manik-library/ManikEntityService';
import { ISmartMedia } from 'src/app/smart-media-handler/smart-media.interface';

@Component({
  selector: 'app-microsite-candid',
  templateUrl: './microsite-candid.component.html'
})
export class MicrositeCandidComponent extends ManikEntityFE implements OnInit {
  EffectForm: FormGroup;
  public GModel: GalleryModel = new GalleryModel();
  public DesignerEffects: { DataValue: string; DataText: string };
  @Input() public EditOption: IEditOptions;
  public AddBackgroundMedia: boolean = false;
  IsPageLoaded: boolean = false;
  constructor(private formBuilder: FormBuilder,private cdRef: ChangeDetectorRef, private _manikEntityService: ManikEntityService, @Inject(DOCUMENT) public document: any) {
    super(document);
    this.EffectForm = this.formBuilder.group({
      SelectedEffectID: [0, Validators.required]
    });
  }

  ngOnInit() {
    if (this.EditOption.PortalContext) {
      sessionStorage.setItem('PortalIdentifier', this.EditOption.PortalContext);
      sessionStorage.setItem('PortalDS', this.EditOption.PortalDS);
    }
    this.GModel.IsPageLoaded = true;
    this.GModel.BusinessID = this.EditOption.BusinessID;
    this.populateControls();
  }

  populateControls(): void {
    let param = this.GModel.BusinessID + "_" + this.EditOption.Type;
    this._manikEntityService.manikEntityConnect2(this.EndPoint+"entitymgr", null,
      this.prepareEditHeaders2(param, "MICROPAGE", "BIZ", this.EditOption.PortalContext))
      .subscribe(data => {
        this.IsPageLoaded = true;
        this.GModel.ImageList = data.ManikJSon[0].JSon0;
        this.BindEffects(this.GModel.ImageList[0].MicrositeSectionID);
        // if (this.GModel.ImageList[0].UseBGMedia === "Y") {
        this.AddBackgroundMedia = true;
        this.GModel.SmartMediaBG.MediaID = this.GModel.ImageList[0].BGMediaHandle;
        // this.cdRef.detectChanges(); 
        //}
      }, err => err);
  }

  BindEffects(MicrositeSectionID: number): void {
    this.updateFilterParams(MicrositeSectionID);
    this._manikEntityService.manikEntityConnect2(this.EndPoint+"entitymgr", null,
      this.prepareAddlQueryHeaders2("ULTRA.QUICK", "MICROSITE.DESIGNER.EFFECTS", "BIZ", this.EditOption.PortalContext))
      .subscribe(data => {
        this.DesignerEffects = data.ManikJSon[0].JSon0;
        this.updateFilterParams(this.GModel.BusinessID, MicrositeSectionID);
        this._manikEntityService.manikEntityConnect2(this.EndPoint+"entitymgr", null,
          this.prepareAddlQueryHeaders2("GET.SELECTED.EFFECT", "MICROSITE.MENU", "BIZ", this.EditOption.PortalContext))
          .subscribe(data => {
            this.EffectForm.controls.SelectedEffectID.patchValue(data.ManikJSon[0].JSon0[0].SelectedEffectID);
          });
      });
  }

  PopulateMenu2(item: any) {
    this.GModel.IsPageSettingActive = false;
    this.GModel.IsParagraphSettingActive = false;
    this.GModel.IsEffectsActive = false;
    this.GModel.IsBackgroundActive = false;
    this.GModel.ShowPageSettings = false;
    this.GModel.ShowSectionList = false;
    this.GModel.ShowBackgroundSettings = false;
    this.GModel.AddEffects = false;
    switch (item) {
      case "Page":
        this.GModel.IsPageSettingActive = true;
        this.GModel.ShowPageSettings = true;
        break;
      case "Section":
        this.GModel.IsParagraphSettingActive = true;
        this.GModel.ShowSectionList = true;
        break;
      case "Background":
        this.GModel.IsBackgroundActive = true;
        this.GModel.ShowBackgroundSettings = true;
        break;
      case "Effects":
        this.GModel.IsEffectsActive = true;
        this.GModel.AddEffects = true;
        break;
    }
  }

  SubmitPageEffect(event: any): void {
    if (this.EffectForm.invalid)
      return;
    let body: any = this.EffectForm.value;
    this.updateFilterParams(this.GModel.BusinessID, this.GModel.ImageList[0].MicrositeSectionID, body.SelectedEffectID);
    this._manikEntityService.manikEntityConnect2(this.EndPoint+"entitymgr", null,
      this.prepareAddlQueryHeaders2("UPDATE.EFFECT", "MICROSITE.MENU", "BIZ", this.EditOption.PortalContext))
      .subscribe(data => {
        let id = data.ManikJSon[0].JSon0;
        if (id != null) {
          this.showNotification('bottom', 'right', 'success', 'Paragraph setting update: Success');
          this.populateControls();
        }
      },
        error => {
          this.showNotification('bottom', 'right', 'danger', 'Paragraph setting update: Failure');
          this.populateControls();
        });
  }

  get frmEft() {
    return this.EffectForm.controls;
  }
}

export class GalleryModel {
  public IsPageLoaded: boolean = false;
  public PageData: any = [];
  public SectionData: any = [];
  public ImageList: any = [];
  public ShowSectionList: boolean = false;
  public ShowBackgroundSettings: boolean = false;
  public BusinessID: string = "";
  public SmartMediaBG: ISmartMedia = { MediaID: "", LGContext: "BIZ", ShowItems: "NFICVYSOP", ShowEditOptions: true, View: 'E' };
  public IsPageSettingActive: boolean = true;
  public AddEffects: boolean = false;
  public IsParagraphSettingActive: boolean = false;
  public IsEffectsActive: boolean = false;
  public IsBackgroundActive: boolean = false;
  public ShowPageSettings: boolean = true;
}
